export const appRoutes = {
  home: '/',
  authenticator: import.meta.env.VITE_AUTHENTICATOR_URL,
  howItWorks: '/how-it-works',
  contact: '/contact',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  notFound: '/*'
} as const
